import React from 'react';
import { X, Check } from 'lucide-react';
export function UpsellSection() {
  const withoutUpsell = ['Explicás lo básico', 'No podés profundizar', 'Falta conexión con la realidad productiva'];
  const withUpsell = ['Casos reales de soja, ganadería y producción', 'Simulación de emprendimientos agro', 'Análisis económico completo', 'Toma de decisiones reales', 'Escenarios de inflación y costos', 'Actividades avanzadas listas'];
  return <section className="py-10 md:py-16 px-4 bg-brand-dark" data-id="element-281">
      <div className="max-w-4xl mx-auto" data-id="element-282">
        <div className="text-center mb-10" data-id="element-283">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2" data-id="element-284">
            🔥 ¿QUÉ AGREGA EL UPSELL?
          </h2>
          <p className="text-lg md:text-xl font-bold text-brand-accent neon-glow" data-id="element-285">
            💣 “ECONOMÍA AGRO AVANZADA + SIMULACIÓN REAL”
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-286">
          {/* Sin Upsell */}
          <div className="bg-brand-card rounded-xl border border-red-500/30 p-6" data-id="element-287">
            <h3 className="text-xl font-black text-red-400 mb-6 flex items-center justify-center" data-id="element-288">
              <X className="w-6 h-6 mr-2" data-id="element-289" /> ❌ Sin upsell
            </h3>
            <ul className="space-y-4" data-id="element-290">
              {withoutUpsell.map((item, i) => <li key={i} className="flex items-start" data-id="element-291">
                  <X className="w-5 h-5 text-red-500/70 mr-3 shrink-0 mt-0.5" data-id="element-292" />
                  <span className="text-gray-400 font-medium" data-id="element-293">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Con Upsell */}
          <div className="bg-brand-card rounded-xl border-2 border-brand-accent p-6 shadow-[0_0_15px_rgba(34,197,94,0.15)]" data-id="element-294">
            <h3 className="text-xl font-black text-brand-accent mb-6 flex items-center justify-center neon-glow" data-id="element-295">
              <Check className="w-6 h-6 mr-2" data-id="element-296" /> ✅ Con upsell
            </h3>
            <ul className="space-y-4" data-id="element-297">
              {withUpsell.map((item, i) => <li key={i} className="flex items-start" data-id="element-298">
                  <Check className="w-5 h-5 text-brand-accent mr-3 shrink-0 mt-0.5" data-id="element-299" />
                  <span className="text-white font-bold" data-id="element-300">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="text-center" data-id="element-301">
          <p className="text-xl md:text-2xl font-black text-white bg-brand-card inline-block px-6 py-3 rounded-lg border border-white/10" data-id="element-302">
            👉 Esto convierte tus clases en{' '}
            <span className="text-brand-accent neon-glow" data-id="element-303">
              EXPERIENCIAS REALES
            </span>
          </p>
        </div>
      </div>
    </section>;
}